@if (!!filteredRooms) {
    <div class="container">
        <form [formGroup]="filtersForm" novalidate>
            <div class="search-div">
                <mat-icon class="search-icon" [ngClass]="{ 'active-filter': !!filtersForm.controls['searchControlName'].value }">search</mat-icon>
                <mat-form-field class="global-search-term">
                    <input matInput formControlName="searchControlName" [ngClass]="{ 'active-filter': !!filtersForm.controls['searchControlName'].value }" (input)="onSearch()" />
                    <fa-icon
                        [icon]="resetFilterIcon"
                        class="icon-reset-filter"
                        [ngClass]="{ 'active-filter': !!filtersForm.controls['searchControlName'].value }"
                        matSuffix
                        matTooltip="Réinitialiser la recherche"
                        (click)="resetFilter()"></fa-icon>
                </mat-form-field>
            </div>
        </form>
        @if (filteredRooms.length === 0) {
            <p>Pas de conversation</p>
        }
        <div class="rooms">
            @for (room of filteredRooms; track room.guid) {
                <div class="room" [ngClass]="{ selected: selectedRoom === room }" (click)="onSelected(room)">
                    <app-tchat-user-identity
                        class="room"
                        [ngClass]="{ selected: selectedRoom === room }"
                        [user]="room.target"
                        [isLiveTchat]="true"
                        [notifications]="room.notifications"
                        (click)="onSelected(room)"></app-tchat-user-identity>
                    <div class="last-message">
                        @if ((room.messages[room.messages.length - 1].date | date: FRENCH_DATE_FORMAT) === (getCurrentDate() | date: FRENCH_DATE_FORMAT)) {
                            <p>
                                {{ room.messages[room.messages.length - 1].date | date: 'HH:mm' }}
                            </p>
                        }
                        @if ((room.messages[room.messages.length - 1].date | date: FRENCH_DATE_FORMAT) !== (getCurrentDate() | date: FRENCH_DATE_FORMAT)) {
                            <p>
                                {{ room.messages[room.messages.length - 1].date | date: 'dd/MM' }}
                            </p>
                        }
                        <p class="message">{{ room.messages[room.messages.length - 1].text }}</p>
                    </div>
                </div>
            }
        </div>
    </div>
}
